import Box from '@mui/material/Box';
import { useEffect, useMemo, useState } from 'react';
import { SidebarGroup } from '@backstage/core-components';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { developerPortalSupportAgentApiRef } from '../../api';
import { IconComponent, useApi } from '@backstage/core-plugin-api';
import { NavDeveloperAssistantIcon } from '../icons/NavDeveloperAssistantIcon';

const ICON_SIZE = 20;

export const DeveloperAssistantSidebarItem = () => {
  const api = useApi(developerPortalSupportAgentApiRef);
  const [canRead, setCanRead] = useState(false);

  const SmallIcon: IconComponent = useMemo(
    () => props =>
      (
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            '& svg': {
              width: ICON_SIZE,
              height: ICON_SIZE,
              fontSize: ICON_SIZE,
            },
          }}
        >
          <NavDeveloperAssistantIcon {...props} />
        </Box>
      ),
    [],
  );

  useEffect(() => {
    api
      .checkPermissions()
      .then(perms => setCanRead(perms.read))
      .catch(() => setCanRead(false));
  }, [api]);

  if (!canRead) return null;

  return (
    <SidebarGroup
      label="Developer Assistant"
      icon={<SmallIcon />}
      to="/developer-assistant"
    >
      <SidebarItem
        icon={SmallIcon}
        to="/developer-assistant"
        text="Developer Assistant"
      />
    </SidebarGroup>
  );
};
